import { Injectable, ErrorHandler, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, JSONRPCError, JSONRPCErrorCode, NetworkError } from '@s8l/client-tree-lib';
import * as Sentry from '@sentry/browser';

import { environment } from 'src/environments/environment';

import { AlertService } from './alert.service';

if (environment.production) {
  Sentry.init({ dsn: 'https://259a9701911641b9a279d6a906fbfd6e@crash.str8labs.net/12' });
}

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private auth: AuthService, private alert: AlertService, private router: Router, private zone: NgZone) {}

  public async handleError(error: any) {
    const err = error.rejection || error.originalError || error;

    console.warn('Handled Error: ', err);

    if (err instanceof JSONRPCError) {
      if (err.code === JSONRPCErrorCode.INTERNAL_ERROR || err.code === JSONRPCErrorCode.INTERNAL_JSONRPC_ERROR) {
        await this.alert.fireError('Internal Error', 'An unknown error has occurred. A bug report has been sent to the developers.');
        Sentry.captureException(error.originalError || error);
      } else if (err.code === JSONRPCErrorCode.UNAUTHORIZED) {
        if (err.message === 'Insufficient permission') {
          this.auth.unauth();
          await this.alert
            .fireError('Insufficient Permission', 'You are not allowed to access this page')
            .then(() => this.zone.run(() => this.router.navigate(['/login'])));
        } else {
          this.auth.unauth();
          await this.alert
            .fireError('Logout', 'You have been automatically logged out')
            .then(() => this.zone.run(() => this.router.navigate(['/login'])));
        }
      } else if (err.code === JSONRPCErrorCode.TOO_MANY_REQUESTS) {
        await this.alert.fireError('Login failed', 'Please try again later');
      } else {
        await this.alert.fireError('Unknown Error', 'An unknown error has occurred. A bug report has been sent to the developers.');
        Sentry.captureException(error.originalError || error);
      }
    } else if (err instanceof NetworkError) {
      await this.alert.fireError('Network Error', 'The connection was lost, please try again later.');
    } else {
      await this.alert.fireError('Unknown Error', 'An unknown error has occurred. A bug report has been sent to the developers.');
      Sentry.captureException(error.originalError || error);
    }
  }
}
